export { CareersPage as default } from '@/components/enpages/Careers'
